import React from 'react'

import Category from "@/components/Category"

export default function CategoryList({ categories }) {
	return (
		<div className="flex flex-wrap justify-center items-center gap-8">
			{categories.map(category => (
				<Category 
					key={category.id}
					imgSrc={category.img_url || "https://images.pexels.com/photos/594610/pexels-photo-594610.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"}
					title={category.name}
					link={`/products?category=${category.id}&name=${category.name}`}
				/>
			))}
		</div>
	)
}